import React from 'react';
import DOMPurify from 'dompurify';

type Props = {
  text: string;
};

export const TextWithHTML = ({ text }: Props): JSX.Element => {
  const formattedText = text.replace(/\n/g, '<br />');
  const sanitizedText = DOMPurify.sanitize(formattedText);
  return <div dangerouslySetInnerHTML={{ __html: sanitizedText }} />;
};
